import { render } from "./fxry.vue?vue&type=template&id=70b321b2&scoped=true"
import script from "./fxry.vue?vue&type=script&lang=js"
export * from "./fxry.vue?vue&type=script&lang=js"

import "./fxry.vue?vue&type=style&index=0&id=70b321b2&scoped=true&lang=css"

import exportComponent from "D:\\智诚大数据\\禁种铲毒\\禁种铲毒平台\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b321b2"]])

export default __exports__